export default __webpack_public_path__ + "static/media/Close.96ad051c.svg";